import Component from '../inherited/Component'
import Helpers from '../lib/Helpers'

export default class Header extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._lastScrollY = 0
    this._currentScrollY = window.scrollY
    this._currentDirection = 'down'
    this._header = document.querySelector(this._options.header)
    this._headerHeight = this._header.getBoundingClientRect().height
  }
 
  mount () {
    document.addEventListener('click', this._handleDocumentClick);

    window.addEventListener('scroll', e => {
      this._assignVariables()
      this._doScrollCalculations()
    }, { passive: true })  

    this._assignVariables()
    this._doScrollCalculations()
  }


  _handleDocumentClick(event) {
    const  searchFormItem =  document.querySelector('.search-form-item');
    const rightNavArea =  document.querySelector('.right-nav-area');
    const leftNavArea = document.querySelector('.left-nav-area');
    if (!searchFormItem.contains(event.target)) {
      rightNavArea.classList.remove('expanded-nav');
    }
  }
  
  _doScrollCalculations () {
    
    if (window.scrollY >= 0) {
      this._header.classList.add('fixed')
    } else {
      this._header.classList.remove('fixed')
    }

  }

  _assignVariables () {
    this._currentScrollY = window.scrollY
    this._currentDirection = this._currentScrollY > this._lastScrollY ? 'down' : 'up'
    this._lastScrollY = window.scrollY
  }
}